"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nullable = void 0;
// import { TNull, TSchema, TUnion, Type } from '@sinclair/typebox';
const typebox_1 = require("@sinclair/typebox");
/*
export const Nullable = <T extends TSchema>(schema: T): TUnion<[T, TNull]> =>
  Type.Optional(
    Type.Union([
      Type.Unsafe({
        ...schema,
        nullable: schema && schema.type ? true : undefined,
      }) as T,
      Type.Null(),
    ]),
  );
 */
const Nullable = (schema) => typebox_1.Type.Optional(typebox_1.Type.Union([schema, typebox_1.Type.Null()]));
exports.Nullable = Nullable;
// export type Nullable<T extends TSchema> = Static<typeof Nullable<T>>;
//# sourceMappingURL=nullable.js.map